import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getSignatureStart,
  getSignatureSuccess,
  getSignatureFailed,
} from "../redux/getSignature";

import { getImageApi } from "core/http/service/personnelInformation";

function* getSignatureWork() {
  try {
    const res = yield call(getImageApi, { type: "SIGNATURE_IMAGE" });

    yield put({
      type: getSignatureSuccess.type,
      payload: res,
    });
  } catch (error: any) {
    yield put({
      type: getSignatureFailed.type,
    });
  }
}

function* watchGetSignature() {
  yield takeLatest(getSignatureStart.type, getSignatureWork);
}

export default function* getSignatureSaga() {
  yield all([watchGetSignature()]);
}
